import React from 'react';
import { FormGroup, FormControlLabel, Checkbox as MUICheckbox } from '@mui/material';
import Campos from '../GeneralComponents/campos';

const CedulaSelector = ({
    cedulas,
    selectedCedulaIds,
    onCedulaChange,
    mensajeError,
    valueError
}) => {
    return (
        <Campos
            label={"Cédulas profesionales"}
            textError={mensajeError}
            valueError={valueError}
        >
            <FormGroup>
                {cedulas.map((cedulaItem) => (
                    <FormControlLabel
                        key={cedulaItem.id}
                        control={
                            <MUICheckbox
                                value={cedulaItem.id}
                                checked={selectedCedulaIds.includes(cedulaItem.id)}
                                onChange={() => onCedulaChange(cedulaItem.id)}
                                name={cedulaItem.label}
                            />
                        }
                        label={cedulaItem.label}
                    />
                ))}
            </FormGroup>
        </Campos>
    );
};

export default CedulaSelector;
